import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white/80 backdrop-blur-md sticky top-0 z-50 shadow-sm" data-id="element-147">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-148">
        <div className="flex items-center" data-id="element-149">
          <h1 className="text-xl font-bold text-purple-700" data-id="element-150">
            Reto de Meditación
          </h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-151">
          <a href="#problema" className="text-gray-600 hover:text-purple-700 transition-colors" data-id="element-152">
            El Problema
          </a>
          <a href="#solucion" className="text-gray-600 hover:text-purple-700 transition-colors" data-id="element-153">
            La Solución
          </a>
          <a href="#beneficios" className="text-gray-600 hover:text-purple-700 transition-colors" data-id="element-154">
            Beneficios
          </a>
          <a href="#incluye" className="text-gray-600 hover:text-purple-700 transition-colors" data-id="element-155">
            Qué Incluye
          </a>
          <a href="#pricing" className="bg-purple-600 text-white px-5 py-2 rounded-full hover:bg-purple-700 transition-colors" data-id="element-156">
            Comenzar Ahora
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-157">
          {isMenuOpen ? <XIcon size={24} data-id="element-158" /> : <MenuIcon size={24} data-id="element-159" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <nav className="md:hidden bg-white py-4 px-4 shadow-md" data-id="element-160">
          <div className="flex flex-col space-y-4" data-id="element-161">
            <a href="#problema" className="text-gray-600 hover:text-purple-700 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-162">
              El Problema
            </a>
            <a href="#solucion" className="text-gray-600 hover:text-purple-700 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-163">
              La Solución
            </a>
            <a href="#beneficios" className="text-gray-600 hover:text-purple-700 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-164">
              Beneficios
            </a>
            <a href="#incluye" className="text-gray-600 hover:text-purple-700 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-165">
              Qué Incluye
            </a>
            <a href="#pricing" className="bg-purple-600 text-white px-5 py-2 rounded-full hover:bg-purple-700 transition-colors text-center" onClick={() => setIsMenuOpen(false)} data-id="element-166">
              Comenzar Ahora
            </a>
          </div>
        </nav>}
    </header>;
}